import styled from "styled-components";

export const Container = styled.div(({ theme }) => {
    return {
        padding: theme.spacing.medium,
    };
});
